import React, { useState, useEffect } from 'react';
import { collection, getDocs, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';
import './AdminPanel.css';

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);

  // Basit şifre kontrolü (production'da daha güvenli bir yöntem kullanın)
  // Bu şifreyi değiştirmeyi unutmayın!
  const ADMIN_PASSWORD = 'admin123';

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      loadReviews();
    } else {
      alert('Yanlış şifre!');
    }
    setPassword('');
  };

  const loadReviews = async () => {
    setLoading(true);
    try {
      const reviewsRef = collection(db, 'reviews');
      const q = query(reviewsRef, orderBy('timestamp', 'desc'));
      const querySnapshot = await getDocs(q);
      const reviewsData = [];
      querySnapshot.forEach((doc) => {
        reviewsData.push({ id: doc.id, ...doc.data() });
      });
      setReviews(reviewsData);
    } catch (error) {
      console.error('Yorumlar yüklenirken hata:', error);
      alert('Yorumlar yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (reviewId) => {
    if (window.confirm('Bu yorumu silmek istediğinize emin misiniz?')) {
      try {
        await deleteDoc(doc(db, 'reviews', reviewId));
        alert('Yorum başarıyla silindi!');
        loadReviews();
      } catch (error) {
        console.error('Yorum silinirken hata:', error);
        alert('Yorum silinirken bir hata oluştu.');
      }
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="admin-login-container">
          <h2>Admin Girişi</h2>
          <form onSubmit={handleLogin}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifre"
              required
            />
            <button type="submit">Giriş Yap</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-container">
        <div className="admin-header">
          <h1>Admin Paneli</h1>
          <button onClick={() => setIsAuthenticated(false)} className="logout-btn">
            Çıkış Yap
          </button>
        </div>

        <button onClick={loadReviews} className="refresh-btn" disabled={loading}>
          {loading ? 'Yükleniyor...' : 'Yorumları Yenile'}
        </button>

        <div className="admin-reviews-list">
          {reviews.length === 0 ? (
            <p className="no-reviews-admin">Henüz yorum yok.</p>
          ) : (
            reviews.map((review) => (
              <div key={review.id} className="admin-review-card">
                <div className="admin-review-header">
                  <div>
                    <h3>{review.name}</h3>
                    <span className="review-date">{review.date}</span>
                    <div className="review-rating">
                      {'⭐'.repeat(review.rating)}
                    </div>
                  </div>
                  <button
                    onClick={() => handleDelete(review.id)}
                    className="delete-btn"
                  >
                    🗑️ Sil
                  </button>
                </div>
                <p className="review-comment">{review.comment}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;

